import { APP } from 'Constants/App'
import { IKoreanLeadingSchool, KoreanLeadingSchoolPayload, normalizeKoreanLeadingSchoolsList } from 'Entities/koreanLeadingSchool'
import httpClient from 'Service'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

const LIST_KEY = 'korean-leading-schools-list'

const fetchLeadingSchools = async (): Promise<IKoreanLeadingSchool[]> => {
  const response = await httpClient.get('/api/org/korean-leading-schools')
  return normalizeKoreanLeadingSchoolsList(response.data)
}

export const useKoreanLeadingSchools = () => {
  const queryClient = useQueryClient()

  const listQuery = useQuery({
    queryKey: [LIST_KEY],
    queryFn: fetchLeadingSchools,
  })

  const createMutation = useMutation({
    mutationFn: (payload: KoreanLeadingSchoolPayload) => httpClient.post('/api/account/korean-leading-schools', payload),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_SAVED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({ leadingSchoolId, payload }: { leadingSchoolId: number; payload: KoreanLeadingSchoolPayload }) =>
      httpClient.patch(`/api/account/korean-leading-schools/${leadingSchoolId}`, payload),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_CHANGED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (leadingSchoolId: number) => httpClient.delete(`/api/account/korean-leading-schools/${leadingSchoolId}`),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_REMOVED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
  })

  return {
    leadingSchools: listQuery.data ?? [],
    isLeadingSchoolsLoading: listQuery.isLoading,
    isLeadingSchoolsFetching: listQuery.isFetching,
    createLeadingSchoolMutation: createMutation,
    updateLeadingSchoolMutation: updateMutation,
    deleteLeadingSchoolMutation: deleteMutation,
  }
}
